export default "__VITE_ASSET__dYKmeNd7__"